


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IRequestsData } from '../classes';

@Component
export default class CollapsedRequestsChart
    extends Vue {

    @Prop({ required: true, })
    public requestsData?: IRequestsData;

    private mounted(): void {
        if (!this.requestsData) { throw new Error('requestsData is not set'); }
    }

    private get consumptionsCountWithoutDelay(): number {
        return this.requestsData!.countWithoutDelay;
    }
    private get consumptionsCountPostponed(): number {
        return this.requestsData!.countPostponed;
    }
    private get consumptionsCountWithDelay(): number {
        return this.requestsData!.countWithDelay;
    }
    private get totalCount(): number {
        return this.requestsData!.getTotalRequestCount();
    }

    private get consumptionsCountWithoutDelayWidth(): number {
        const total = this.totalCount;
        let result;
        if (total === 0) {
            result = 100 / 3;
        } else {
            result = this.consumptionsCountWithoutDelay
                / total
                * 100;
        }
        return result;
    }
    private get consumptionsCountPostponedWidth(): number {
        const total = this.totalCount;
        let result;
        if (total === 0) {
            result = 100 / 3;
        } else {
            result = this.consumptionsCountPostponed
                / total
                * 100;
        }
        return result;
    }
    private get consumptionsCountWithDelayWidth(): number {
        const total = this.totalCount;
        let result;
        if (total === 0) {
            result = 100 / 3;
        } else {
            result = this.consumptionsCountWithDelay
                / total
                * 100;
        }
        return result;
    }
}
